module.exports = __webpack_public_path__ + "static/img/wall-outlet-mk-1_256.c5699a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-outlet-mk-1_256.png
// module id = qv7w
// module chunks = 0